import { render, staticRenderFns } from "./lottostatus.vue?vue&type=template&id=7fbc7bc8&scoped=true&"
import script from "./lottostatus.vue?vue&type=script&lang=js&"
export * from "./lottostatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc7bc8",
  null
  
)

export default component.exports